import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserPaintGame from 'src/games/PaintGame/Main';

interface PaintGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class PaintGame extends React.Component<PaintGameProps> {
    constructor(props: PaintGameProps) {
        super(props);
        bindAllOfThis(this, PaintGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserPaintGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default PaintGame;



// WEBPACK FOOTER //
// ./src/pages/game/PaintGame.tsx